module.exports = __webpack_public_path__ + "img/id.df61f9d5.png";